module.exports = __webpack_public_path__ + "img/智慧警务-数据中台软件V2.0.a3921f3d.jpg";